import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/arrow-customize-builder-back.svg'


const _hoisted_1 = { class: "name-facade" }
const _hoisted_2 = { class: "price-facade" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: _normalizeClass(["dropdown-button open-slider", { active: $setup.fadeInEffect }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openFacadeSlider()))
    }, "Choose your facade", 2),
    ($setup.isSliderOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["facade-options", { scrollable: $setup.isMoreClicked }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleFacades, (facade) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "facade-card",
              key: facade._id
            }, [
              _createVNode($setup["ToggleButton"], {
                modelValue: $setup.selectedFacadeIds[facade._id],
                additionalClass: ['large', 'margin'],
                labelBold: 'toggle-title-font bolder',
                labelClass: 'flex-column',
                labelHidden: !$setup.selectedFacadeIds[facade._id] ? 'hidden-text' : '',
                label: $setup.selectedFacadeIds[facade._id] ? 'Selected' : 'Not Selected',
                "onUpdate:modelValue": (value) => $setup.updateSelectedFacade(facade, value)
              }, null, 8, ["modelValue", "labelHidden", "label", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_1, _toDisplayString(facade.name), 1),
              _createElementVNode("div", _hoisted_2, _toDisplayString($setup.isNoAdditionalCharge(facade.price) ? "No Additional Charge" : $setup.formatPrice(facade.price)), 1),
              _createElementVNode("img", {
                class: "image-facade",
                src: facade.url,
                alt: facade.name
              }, null, 8, _hoisted_3)
            ]))
          }), 128)),
          ($setup.showMoreButton)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "button-more",
                onClick: $setup.handleMoreClick
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("img", {
                  class: "arrow-more",
                  src: _imports_0
                }, null, -1),
                _createElementVNode("span", { class: "text-more" }, "More", -1)
              ]))]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}